

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_146_2_useOverlayScrollbarinitialization";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_146_2_useOverlayScrollbarinitialization__root"};
export var keyframes = {"os-size-observer-appear-animation":"wds_1_146_2_useOverlayScrollbarinitialization__os-size-observer-appear-animation"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"os-vaw":"--os-vaw","os-vah":"--os-vah"}; 




